import { render, staticRenderFns } from "./instantwin_message_add_edit.vue?vue&type=template&id=e18d8d6a&scoped=true"
import script from "./instantwin_message_add_edit.vue?vue&type=script&lang=ts"
export * from "./instantwin_message_add_edit.vue?vue&type=script&lang=ts"
import style0 from "./instantwin_message_add_edit.vue?vue&type=style&index=0&id=e18d8d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18d8d6a",
  null
  
)

export default component.exports